import { Platform } from 'react-native';
import { COLOR, FONT_SIZE } from 'constants/design-system';

import { BaseText } from 'components/BaseText';

export type TextWithIconProps = {
  title: string;
};

export const HeaderText = (props: TextWithIconProps) => {
  const { title } = props;

  return (
    <BaseText
      fontSize={FONT_SIZE.theme.base}
      color={COLOR.theme.white}
      style={[
        {
          flexShrink: 1,
          flexWrap: 'wrap',
        },
        Platform.OS === 'web' && ({ wordBreak: 'break-word' } as any),
      ]}
    >
      {title}
    </BaseText>
  );
};
